import { Dispatch } from "redux";
import { setOrganizationInvitations, setOrganizationInvitationsLoading } from "@redux/actions/organization-invitations-actions";
import { FormattedAxnAdminUserInvitation } from "@idw-types/data/axn-admin-user-invitation";
import { getAxnAdminUserInvitationsRequest } from "@requests/axnadmin-core/get-axn-admin-user-invitations";
import { AxnAdminUserPropertyBundle } from "@idw-types/data/axn-admin-user-property-bundle";
import { AxnCompany, AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { formatAxnAdminUserInvitations } from "@formatters/axn-admin-user-invitations/axn-admin-user-invitation-formatter";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const getOrganizationInvitationsReduxRequest = (dispatch: Dispatch) => async (
    axnAdminUserPropertyBundles: Array<AxnAdminUserPropertyBundle>,
    axnCompanies: Array<AxnCompany>,
    axnRelyingParties: Array<AxnRelyingParty>
): Promise<Array<FormattedAxnAdminUserInvitation>> => {
    dispatch(setOrganizationInvitationsLoading(true));
    const { data, error } = await getAxnAdminUserInvitationsRequest();
    if (data?.axnAdminUserInvitations) {
        const formattedAxnAdminUserInvitations = formatAxnAdminUserInvitations(
            data.axnAdminUserInvitations,
            axnAdminUserPropertyBundles,
            axnCompanies,
            axnRelyingParties
        );
        dispatch(setOrganizationInvitations(formattedAxnAdminUserInvitations));
        return formattedAxnAdminUserInvitations;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getOrganizationInvitations.error.title,
                resources.requests.getOrganizationInvitations.error.message
            );
        }
        dispatch(setOrganizationInvitationsLoading(false));
        return null;
    }
};